import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { cn } from "~/components/ui/cn";
import { OrderFulfilledIcon } from "~/components/ui/icons/order-fulfilled";
import { OrderTagFulfillment } from "~/graphql/graphql-new.gen";

import { OrderUnfulfilledIcon } from "../ui/icons/order-unfulfilled";
import { OrderBadge } from "./order-badge";

export const getOrderFulfillmentLabelFromTag = (
  tag: OrderTagFulfillment,
  t: TFunction,
) => {
  switch (tag) {
    case OrderTagFulfillment.Fulfilled:
      return t("order.status.fulfillment.fulfilled");
    case OrderTagFulfillment.Unfulfilled:
      return t("order.status.fulfillment.unfulfilled");
  }
};

const variant = ({
  isCancelled,
  tag,
}: {
  isCancelled?: boolean;
  tag: OrderTagFulfillment;
}) => {
  if (isCancelled) return "filled";
  return tag === OrderTagFulfillment.Unfulfilled ? "warning" : "filled";
};

export const OrderFulfillmentBadge: React.FC<{
  isCancelled?: boolean;
  tag: OrderTagFulfillment;
}> = ({ isCancelled, tag }) => {
  const { t } = useTranslation();

  return (
    <OrderBadge variant={variant({ isCancelled, tag })}>
      <div className="flex items-center gap-x-1">
        {tag === OrderTagFulfillment.Unfulfilled ? (
          <OrderUnfulfilledIcon />
        ) : (
          <OrderFulfilledIcon />
        )}
        <span className={cn({ "line-through": isCancelled })}>
          {getOrderFulfillmentLabelFromTag(tag, t)}
        </span>
      </div>
    </OrderBadge>
  );
};
